interface Props {
  [key: string]: any
}

function SearchAltIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 24 24" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M21 21L16.66 16.66"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default SearchAltIcon
